import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './styles.css';
import { routes } from '@/admin/routes';
import { AuthProvider } from '@/admin/contexts/auth-context';

const router = createBrowserRouter(routes);

const App: React.FC = () => {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
};

export default App;
